<section class="events-pane-container">
    <section class="period-container">
        <div class="period-dropdown">
            <header (click)="openPeriodMenu()">
                <span>{{selectedPeriodName}}</span>
                <i class="fa fas fa-chevron-down chevron-down" [ngClass]="statusPeriodMenu ? 'chevron-collapsed' : ''"></i>
            </header>
            <div class="period-list" [ngClass]="statusPeriodMenu ? 'period-list-collapsed' : ''">
                <a (click)="checkPeriod($event,'pastWeek','Past Week')">Past Week</a>
                <a (click)="checkPeriod($event,'pastMonth','Past Month')">Past Month</a>
                <a (click)="checkPeriod($event,'pastQuarter','Past Quarter')">Past Quarter</a>
                <a (click)="checkPeriod($event,'pastYear','Past Year')">Past Year</a>
                <a (click)="checkPeriod($event,'custom','Custom')">Custom</a>
                <div class="form-group" [ngClass]="{'status-between-periods': statusBetweenPeriods==true}">
                    <input type="text" class="since" placeholder="Start Date" required [(ngModel)]="date1"
                        (click)="checkPeriod($event,'since','Custom')">
                    <input type="text" class="to" placeholder="End Date" required [(ngModel)]="date2"
                        (click)="checkPeriod($event,'to','Custom')">
                    <input type="date" class="since" (click)="checkPeriod($event,'since','Custom')" [(ngModel)]="date1" />
                    <input type="date" class="to" (click)="checkPeriod($event,'to','Custom')" [(ngModel)]="date2" />
                    <span *ngIf="errorMessage" class="invalid-feedback">You must fill in the dates.</span>
                    <span class="click-period" (click)="checkPeriod($event,'clickPeriod','Custom')">Update</span>
                </div>
            </div>
        </div>
    </section>
    <section class="events-container">
        <div class="add-button" (click)="addChart()">
            <div class="button"><i class="fas fa-plus"></i>Add Chart</div>
        </div>
        <ng-content select=".chart-type-item"></ng-content>
        <ng-container *ngFor="let chart of charts">
            <app-events-pane [uid]="chart.id" [displayType]="'bar-chart'" (deleted)="deleteWidget($event)">
            </app-events-pane>
        </ng-container>
    </section>
    <div class="add-button" (click)="addTable()">
        <div class="button"><i class="fas fa-plus"></i>Add Table</div>
    </div>
    <ng-content></ng-content>
    <ng-container *ngFor="let table of tables">
        <app-events-pane [uid]="table.id" (deleted)="deleteWidget($event)"></app-events-pane>
    </ng-container>
</section>